import React, {useRef, useState, useEffect} from 'react';
import Loader from '../components/Loader';

import "../assets/styles/PageNotFound.scss";
import tile from '../assets/images/tile-contact.png'

export default function PageNotFound() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    });

    return(
        <>
        {loading ? (<Loader />) : ("")}
        <>
        <section className='not-found'>
            <img src={tile} className='tile'/>
            <img src={tile} className='tile2'/>
            <h1>404 NOT FOUND</h1>
            <h3>Sorry, we can't find the page you're looking for.</h3>

            <a href='/' className="btn btn-black">Take me home</a>
        </section>
        </>
        </>
    );
}